<template>
  <div class="snapinsta-faq">
    <div
      v-for="(item, index) in faqs"
      :key="index"
      class="snapinsta-faq__item"
      :class="{ 'is-open': activeIndex === index }"
    >
      <button
        type="button"
        class="snapinsta-faq__trigger"
        :aria-expanded="activeIndex === index ? 'true' : 'false'"
        @click="toggleFaq(index)"
      >
        <span class="snapinsta-faq__question">{{ item.question }}</span>
        <span class="snapinsta-faq__chevron" aria-hidden="true"></span>
      </button>
      <div
        v-show="activeIndex === index"
        class="snapinsta-faq__panel"
        role="region"
      >
        <div class="snapinsta-faq__answer" v-html="item.answer"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    faqs: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      activeIndex: null,
    };
  },
  methods: {
    toggleFaq (index) {
      if (this.activeIndex === index) {
        this.activeIndex = null;
      } else {
        this.activeIndex = index;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.snapinsta-faq {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.snapinsta-faq__item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fafbfc;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
    background: #fff;
  }

  &.is-open {
    border-color: #93c5fd;
    background: #fff;
    box-shadow: 0 4px 14px rgba(24, 109, 255, 0.08);
  }
}

.snapinsta-faq__trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 18px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: #1e293b;

  &:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }
}

.snapinsta-faq__question {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
  color: #1a202c;
}

.snapinsta-faq__chevron {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  margin-top: -2px;
  border-right: 2px solid #64748b;
  border-bottom: 2px solid #64748b;
  transform: rotate(45deg);
  transition: transform 0.22s ease, margin-top 0.22s ease, border-color 0.2s ease;
}

.snapinsta-faq__item.is-open .snapinsta-faq__chevron {
  margin-top: 4px;
  transform: rotate(225deg);
  border-color: #186dff;
}

.snapinsta-faq__item.is-open .snapinsta-faq__question {
  color: #186dff;
}

.snapinsta-faq__panel {
  padding: 0 18px 16px;
}

.snapinsta-faq__answer {
  padding: 14px 16px;
  border-radius: 8px;
  background: #f1f5f9;
  color: #475569;
  font-size: 15px;
  line-height: 1.65;

  ::v-deep a {
    color: #2563eb;
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ::v-deep p {
    margin: 0;
  }
}

@media (max-width: 768px) {
  .snapinsta-faq__trigger {
    padding: 14px 16px;
  }

  .snapinsta-faq__question {
    font-size: 15px;
  }

  .snapinsta-faq__panel {
    padding: 0 16px 14px;
  }

  .snapinsta-faq__answer {
    padding: 12px 14px;
    font-size: 14px;
  }
}
</style>
